<template>
  <div class="speaker-box">
    <CommonTitle :commonTitle="commonTitle"></CommonTitle>
    <div class="speaker-list">
      <ul class="speaker-li slidetop" data-scroll data-scroll-call="animateMove">
        <li v-for="item in speakerData" :key="item.id">
          <router-link to="/2022/guest">
            <figure><img :src="item.smallface" alt=""/></figure>
            <p v-html="item.user"></p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CommonTitle from '@/components/common/HomeTitle'
export default {
  data () {
    return {
      commonTitle: {
        title: '演讲嘉宾',
        sen: 'SPEAKERs'
      },
      SpeakerList: []
    }
  },
  props: {
    speakerData: Array
  },
  methods: {
    guestview (item) {
      this.$parent.$parent.setPopShow(item)
    }
  },
  components: {
    CommonTitle
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/agenda/index.less");
</style>